import { Row, Col } from 'antd';
import { criiptoAuthMethodsByCountry } from '../../utils/consts';

export const CriiptoMethodsView = ({ methods }) => {
    const getMethodLabel = (countryCode, value) => {
        const countryMethods = criiptoAuthMethodsByCountry.find(
            (m) => m.countryCode === countryCode,
        )?.methods;
        return countryMethods?.find((m) => m.value === value)?.label;
    };
    if (!methods) return null;

    return (
        <div className="details-table__row">
            <div className="details-table__row-head details-table__cell">
                Criipto methods:
            </div>
            {criiptoAuthMethodsByCountry?.map(
                ({ countryCode, countryLabel }) => (
                    <Row key={countryCode}>
                        <Col span={7}>
                            <h3 className="details-table__row-head details-table__cell">
                                {countryLabel}
                            </h3>
                        </Col>
                        <Col span={17}>
                            <div className="details-table__cell">
                                {methods[countryCode]?.length > 0
                                    ? methods[countryCode]
                                          .map((value) =>
                                              getMethodLabel(
                                                  countryCode,
                                                  value,
                                              ),
                                          )
                                          .join(', ')
                                    : '-'}
                            </div>
                        </Col>
                    </Row>
                ),
            )}
        </div>
    );
};
